import React from 'react';
export function Hero() {
  return <section className="py-24 md:py-32 bg-cover bg-center bg-no-repeat relative" style={{
    backgroundImage: `url('https://uploadthingy.s3.us-west-1.amazonaws.com/jfsHVc5qZPmXRJEJLgH3MC/Background_for_Header.jpg')`,
    backgroundSize: 'cover'
  }} data-id="element-273">
      <div className="absolute inset-0 bg-black bg-opacity-40" data-id="element-274"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative" data-id="element-275">
        <div className="flex flex-col items-center text-center" data-id="element-276">
          <div className="max-w-3xl" data-id="element-277">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-278">
              Your Books are Stealing Your Time
            </h1>
            <p className="text-xl text-white font-medium mb-8" data-id="element-279">
              Outsource your bookkeeping and free up time to{' '}
              <span className="relative inline-block" data-id="element-280">
                <span className="relative z-10" data-id="element-281">do the work you love</span>
                <span className="absolute bottom-0 left-0 w-full h-10 bg-[#9BAB6C] opacity-80 z-0" style={{
                maskImage: 'url(\'data:image/svg+xml;utf8,<svg viewBox="0 0 300 40" xmlns="http://www.w3.org/2000/svg"><path d="M8,30 C20,10 30,32 40,25 C60,10 80,38 100,20 C120,5 140,35 160,18 C180,5 200,25 220,15 C240,5 260,30 280,20 C290,15 292,25 300,20 L300,40 L0,40 L0,30 Z" fill="black"/></svg>\')',
                WebkitMaskImage: 'url(\'data:image/svg+xml;utf8,<svg viewBox="0 0 300 40" xmlns="http://www.w3.org/2000/svg"><path d="M8,30 C20,10 30,32 40,25 C60,10 80,38 100,20 C120,5 140,35 160,18 C180,5 200,25 220,15 C240,5 260,30 280,20 C290,15 292,25 300,20 L300,40 L0,40 L0,30 Z" fill="black"/></svg>\')',
                maskSize: '100% 100%',
                WebkitMaskSize: '100% 100%'
              }} data-id="element-282"></span>
              </span>
            </p>
            <div data-id="element-283">
              <a href="https://outlook.office.com/book/MeyerBookkeepingTax@meyerbkt.com/" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#9BAB6C] text-white px-6 py-3 rounded-md text-lg font-medium hover:bg-[#8A9A5B] transition-colors" data-id="element-284">
                Book a Free Discovery Call
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}